import React from "react";
import TrackInfoTool from "../../../components/tools/TrackInfoTool";
import { ExercisesTable } from "../../../components/admin/ExercisesTable";

export function AdminExercisesRoute() {
  return (
    <>
      <ExercisesTable />
      <TrackInfoTool
        trackInfo={{
          name: "Admin - Exercises",
        }}
      />
    </>
  );
}
